//#region Imports
import { drawArrow, drawTapArrow } from "../draw/draw.js";
import {
  getMouse3dDirection,
  rotateAroundAxisY,
  rotateAroundAxisZ,
  rotateAroundAxisX,
  rotateAboutPoint,
} from "../geometry/editObject";
import {
  rotatePoint2D,
  getPointHonBC,
  getPointB,
  calculateDistance2D,
  calculateDistance3D,
} from "@/components/geometry/geometry.js";
import {
  prepareLaplacianDeform,
  applyRotateToGingiva,
  applyMultiselectRotateToGingiva,
  applyMoveToGingiva,
} from "@/components/geometry/gingivaHelper.js";
import {
  ioViewer,
  ioPlane,
  ioRaycaster,
  getIoMouse3dDirection,
  gingivae as ioGingivae,
} from "@/components/intraoral/IntraoralManager";
import { drawMoveRotateGroup } from "../draw/toothHelper.js";
import {
  findToothCollisions,
  findToothAnchorageLoss,
} from "@/components/ortho/OrthoPlanMode.js";
import { getMeshesBox } from "@/components/anchorage/AnchorageCalculation";
//#endregion

const radius = 140; // 14

let offset = new THREE.Vector3();
let selectedMeshes = null;
let crossedMesh = null;
let movedControlMesh = null;
let needUpdate = false;
let clickPoint = new THREE.Vector3();
let clickedTagMesh = null;
let clickControlPoint = new THREE.Vector3();
let normal = new THREE.Vector3();
let rotateAxis = null;
let updateTime = null;
let orthoViewer = null;
let orthoPlane = null;
let orthoRaycaster = null;
let isTeethMoving = false;

let moveContext = {
  id: null,
  editedObject: null,
  tooth: null,
  isVerticalPlane: false,
  angle: 0,
  moveLine: null,
  fromTapArrow: null,
  toTapArrow: null,
  from: null,
  to: null,
};

function enterMoveMode(toothContext) {
  console.log("enterMoveMode", toothContext);
  orthoViewer = vueApp.isIntraoralView ? ioViewer : viewer;
  orthoPlane = vueApp.isIntraoralView ? ioPlane : implantPlane;
  orthoRaycaster = vueApp.isIntraoralView ? ioRaycaster : raycaster;

  moveContext.editedObject = toothContext;
  if (toothContext) {
    toothContext.isMoved = true;
    toothContext.isRotated = toothContext.isResized = false;
    moveContext.id = toothContext.id;
    moveContext.tooth = toothContext.tooth;
    moveContext.angle = toothContext.sliderValue * Math.PI;

    if (toothContext.isMultiselect) {
      selectedMeshes = toothContext.selectedTeeth.map((item) =>
        orthoViewer.get_model_mesh(item.id)
      );
    } else {
      selectedMeshes = [orthoViewer.get_model_mesh(moveContext.id)];
    }
  } else {
    moveContext.id = moveContext.tooth = moveContext.angle = null;
    selectedMeshes = null;
  }

  redrawMoveArrow();
}

function exitMoveMode() {
  moveContext.id = null;
  if (moveContext.moveLine) {
    orthoViewer.scene.remove(moveContext.moveLine);
    if (moveContext.fromTapArrow) {
      orthoViewer.scene.remove(moveContext.fromTapArrow);
      orthoViewer.scene.remove(moveContext.toTapArrow);
    }
  }
}

function redrawMoveArrow() {
  if (moveContext.moveLine) {
    orthoViewer.scene.remove(moveContext.moveLine);
    // moveContext.moveLine = null;
  }
  let toothContext = moveContext.editedObject;
  let angleX = null;
  let angleZ = null;
  if (toothContext && (toothContext.tooth || toothContext.isMultiselect)) {
    let groupCenter = null;
    let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;

    if (toothContext.isMultiselect) {
      let selectedBox = getMeshesBox(selectedMeshes);
      groupCenter = new THREE.Vector3(
        selectedBox.center.x,
        selectedBox.center.y,
        selectedBox.center.z
      );
      moveContext.moveLine = drawMoveRotateGroup(
        null,
        orthoViewer,
        groupCenter
      );
      selectedMeshes.forEach((selectedMesh) => {
        selectedMesh.moveRotateGroup = null;
      });
      if (selectedMeshes.length == 1) {
        prepareLaplacianDeform(
          orthoViewer,
          toothContext.selectedTeeth[0],
          selectedMeshes[0],
          gingivae
        );
      }
    } else {
      let tooth = toothContext.tooth;
      let mesh = orthoViewer.get_model_mesh(toothContext.id);
      orthoPlane.position.copy(mesh.position);
      orthoPlane.lookAt(orthoViewer.camera.position);

      groupCenter = new THREE.Vector3(
        mesh.position.x,
        mesh.position.y,
        mesh.position.z
      );
      if (vueApp.isIntraoralView) {
        let dcenter = tooth.defaultBox.center;
        groupCenter.set(
          groupCenter.x + dcenter.x,
          groupCenter.y + dcenter.y,
          groupCenter.z + dcenter.z
        );
      } else {
        if (mesh.rootCenter) {
          // console.log("rootCenter", mesh.rootCenter);
          groupCenter = mesh.rootCenter.clone();
        }

        if (vueApp.midlineData && tooth.axisPoint1 && tooth.axisPoint2) {
          // let rootPoint = tooth.isUpper ? tooth.axisPoint2 : tooth.axisPoint1;
          // let crownPoint = tooth.isUpper ? tooth.axisPoint1 : tooth.axisPoint2;

          let v1 = tooth.axisPoint1.clone();
          v1.sub(tooth.axisPoint2);

          let v2 = new THREE.Vector3();
          v2.y = v1.y;

          let v1x = v1.clone();
          v1x.x = 0;
          angleX = v1x.angleTo(v2);
          if (v1x.z > 0) angleX = -angleX;

          let v1z = v1.clone();
          v1z.z = 0;
          angleZ = v1z.angleTo(v2);
          if (v1z.x < 0) angleZ = -angleZ;

          let angleDegX = (angleX * 180) / Math.PI;
          let angleDegZ = (angleZ * 180) / Math.PI;
          console.log("midlineData angle x", angleDegX);
          console.log("midlineData angle z", angleDegZ);

        }
      }

      prepareLaplacianDeform(orthoViewer, toothContext.tooth, mesh, gingivae);

      moveContext.moveLine = drawMoveRotateGroup(
        mesh,
        orthoViewer,
        groupCenter
      );

      if (
        moveContext.moveLine &&
        (angleX || angleZ) &&
        !moveContext.moveLine.isRotated
      ) {
        moveContext.moveLine.isRotated = true;

        if (angleX) {
          moveContext.moveLine.rotation.x = angleX;
          // let rotateAxisX = new THREE.Vector3(1, 0, 0);
          // moveContext.moveLine.rotateOnWorldAxis(rotateAxisX, angleX); // rotateOnAxis
        }

        if (angleZ) {
          moveContext.moveLine.rotation.z = angleZ;
          // let rotateAxisZ = new THREE.Vector3(0, 0, 1);
          // moveContext.moveLine.rotateOnWorldAxis(rotateAxisZ, angleZ); // rotateOnWorldAxis
        }
        moveContext.moveLine.updateMatrix();
      }
    }

    moveContext.moveLine.visible = true;
    moveContext.center = new THREE.Vector3(
      groupCenter.x,
      groupCenter.y,
      groupCenter.z
    );
  }
}

function old_redrawMoveArrow() {
  if (crossedMesh) {
    orthoViewer.scene.remove(crossedMesh);
    // crossedMesh = null;
  }

  if (moveContext.fromTapArrow) {
    orthoViewer.scene.remove(moveContext.fromTapArrow);
    orthoViewer.scene.remove(moveContext.toTapArrow);
  }

  let tooth = moveContext.tooth;
  let mesh = orthoViewer.get_model_mesh(moveContext.id);
  orthoPlane.position.copy(mesh.position);
  orthoPlane.lookAt(orthoViewer.camera.position);

  let center = mesh.position;
  let min = {
    x: tooth.defaultBox.min.x + (center.x - tooth.defaultPosition.x),
    y: tooth.defaultBox.min.y + (center.y - tooth.defaultPosition.y),
    z: tooth.defaultBox.min.z + (center.z - tooth.defaultPosition.z),
  };
  let max = {
    x: tooth.defaultBox.max.x + (center.x - tooth.defaultPosition.x),
    y: tooth.defaultBox.max.y + (center.y - tooth.defaultPosition.y),
    z: tooth.defaultBox.max.z + (center.z - tooth.defaultPosition.z),
  };

  let dy = Math.abs(max.y - min.y);

  center = {
    x: center.x,
    y: tooth.isMaxilla ? center.y - dy / 6 : center.y + dy / 6,
    z: center.z,
  };

  let from = moveContext.isVerticalPlane
    ? { x: center.x, y: center.y - radius, z: center.z }
    : { x: center.x - radius, y: center.y, z: center.z };
  let to = moveContext.isVerticalPlane
    ? { x: center.x, y: center.y + radius, z: center.z }
    : { x: center.x + radius, y: center.y, z: center.z };

  let difx = 5;
  let dify = 3;
  let mfrom = moveContext.isVerticalPlane
    ? { x: from.x + difx, y: from.y, z: from.z }
    : { x: from.x, y: from.y - dify, z: from.z };
  let mto = moveContext.isVerticalPlane
    ? { x: to.x + difx, y: to.y, z: to.z }
    : { x: to.x, y: to.y - dify, z: to.z };

  if (moveContext.angle != 0) {
    if (moveContext.isVerticalPlane) {
      var rfrom = rotatePoint2D(center, moveContext.angle, from);
      from.x = rfrom.x;
      from.y = rfrom.y;
      var rto = rotatePoint2D(center, moveContext.angle, to);
      to.x = rto.x;
      to.y = rto.y;

      rfrom = rotatePoint2D(center, moveContext.angle, mfrom);
      mfrom.x = rfrom.x;
      mfrom.y = rfrom.y;
      rto = rotatePoint2D(center, moveContext.angle, mto);
      mto.x = rto.x;
      mto.y = rto.y;
    } else {
      var rfrom = rotatePoint2D(
        { x: center.x, y: center.z },
        moveContext.angle,
        { x: from.x, y: from.z }
      );
      from.x = rfrom.x;
      from.z = rfrom.y;
      var rto = rotatePoint2D({ x: center.x, y: center.z }, moveContext.angle, {
        x: to.x,
        y: to.z,
      });
      to.x = rto.x;
      to.z = rto.y;

      rfrom = rotatePoint2D({ x: center.x, y: center.z }, moveContext.angle, {
        x: mfrom.x,
        y: mfrom.z,
      });
      mfrom.x = rfrom.x;
      mfrom.z = rfrom.y;
      rto = rotatePoint2D({ x: center.x, y: center.z }, moveContext.angle, {
        x: mto.x,
        y: mto.z,
      });
      mto.x = rto.x;
      mto.z = rto.y;
    }
  }

  from = new THREE.Vector3(from.x, from.y, from.z);
  to = new THREE.Vector3(to.x, to.y, to.z);
  mfrom = new THREE.Vector3(mfrom.x, mfrom.y, mfrom.z);
  mto = new THREE.Vector3(mto.x, mto.y, mto.z);

  moveContext.moveLine = drawArrow(from, to);
  if (moveContext.editedObject.showTapArrows) {
    moveContext.fromTapArrow = drawTapArrow(
      mfrom,
      false,
      moveContext.isVerticalPlane,
      moveContext.angle,
      "from",
      true
    );
    moveContext.toTapArrow = drawTapArrow(
      mto,
      true,
      moveContext.isVerticalPlane,
      moveContext.angle,
      "to",
      true
    );
  }

  moveContext.from = new THREE.Vector3(
    from.x,
    tooth.isMaxilla ? from.y + dy / 6 : from.y - dy / 6,
    from.z
  );
  moveContext.to = new THREE.Vector3(
    to.x,
    tooth.isMaxilla ? to.y + dy / 6 : to.y - dy / 6,
    to.z
  );
}

// OBSOLETE
function moveModeMouseDown(tooth, event) {
  if (tooth && tooth.id == moveContext.id) {
    // mesh = orthoViewer.get_model_mesh(tooth.id);
    // if (mesh) {
    //   orthoViewer.controls.enabled = false;
    //   orthoPlane.position.copy(mesh.position);
    //   orthoPlane.lookAt(orthoViewer.camera.position);
    //   var intersects = orthoRaycaster.intersectObject(orthoPlane);
    //   offset.copy(intersects[0].point).sub(orthoPlane.position);
    // }
  } else {
    // selectedMeshes = null;
  }
}

// MOVE&ROTATE control or tooth
function moveModeTagDetected(tag, tagMesh, isShift, intersectPoint) {
  orthoViewer.controls.enabled = false;
  updateTime = window.performance.now();
  console.log("moveModeTagDetected", tag, isShift);
  if (isShift) {
    moveTaggedControl(tag, tagMesh, intersectPoint);
  } else {
    isTeethMoving = true;
    moveToothByTag(tag, tagMesh, intersectPoint);
  }
}

// SHIFT LOGIC
function moveTaggedControl(tag, tagMesh, intersectPoint) {
  movedControlMesh = tagMesh ? tagMesh.parent : null;
  if (movedControlMesh) {
    clickedTagMesh = movedControlMesh.children[0];
    orthoViewer.controls.enabled = false;

    // let tempMesh = orthoViewer.get_model_mesh(moveContext.id);
    let center = (moveContext.center = movedControlMesh.position);
    //  tempMesh.position);
    moveContext.tag = tag;
    moveContext.isRotated =
      tag === "zRotateRing" || tag === "yRotateRing" || tag === "xRotateRing";

    normal.copy(orthoViewer.camera.position).sub(center);
    orthoPlane.position.copy(center);
    orthoPlane.lookAt(orthoViewer.camera.position);
    var intersects = orthoRaycaster.intersectObject(orthoPlane);
    var controlIntersects = orthoRaycaster.intersectObject(clickedTagMesh);
    if (
      !intersects ||
      !intersects.length ||
      !controlIntersects ||
      !controlIntersects.length
    ) {
      movedControlMesh = null;
      clickedTagMesh = null;
      return;
    }
    clickControlPoint.copy(controlIntersects[0].point);

    clickPoint.copy(intersects[0].point);
    offset.copy(intersects[0].point).sub(orthoPlane.position);

    if (moveContext.isRotated) {
      rotateAxis = new THREE.Vector3();
      let rotateRadius = 18;
      let viewPoint = orthoViewer.camera.position;

      let rotateStart = null;
      if (tag == "xRotateRing") {
        // redRing
        if (viewPoint && viewPoint.x < center.x) {
          rotateRadius = -rotateRadius;
        }
        rotateStart = new THREE.Vector3(rotateRadius, 0, 0);
        normal.copy(rotateStart);
      }
      if (tag == "yRotateRing") {
        // blueRing
        if (viewPoint && viewPoint.y < center.y) {
          rotateRadius = -rotateRadius;
        }
        rotateStart = new THREE.Vector3(0, rotateRadius, 0);
        normal.copy(rotateStart);
      } else if (tag == "zRotateRing") {
        // greenRing
        if (viewPoint && viewPoint.z < center.z) {
          rotateRadius = -rotateRadius;
        }
        rotateStart = new THREE.Vector3(0, 0, rotateRadius);
        normal.copy(rotateStart);
      }
      let rotateEnd = new THREE.Vector3(0, 0, 0);
      rotateAxis.subVectors(rotateStart, rotateEnd).normalize();
    }
  }
  // console.log("movedControlMesh", movedControlMesh);
}

function isAnySelected() {
  return (
    selectedMeshes && selectedMeshes.length && selectedMeshes.find((m) => !!m)
  );
}

// TOOTH MOVE&ROTATE
function moveToothByTag(tag, tagMesh, intersectPoint) {
  console.log("moveToothByTag", tag);
  if (isAnySelected() && tag && tagMesh && intersectPoint) {
    clickControlPoint.copy(intersectPoint);

    let movedControlGroup = tagMesh.parent;
    clickedTagMesh = movedControlGroup.children[0];

    let center = (moveContext.center = movedControlGroup.position);
    let boxMatrix = movedControlGroup.matrixWorld;
    selectedMeshes.forEach((selectedMesh) => {
      selectedMesh.subvector = movedControlGroup.position
        .clone()
        .sub(selectedMesh.position);
    });

    normal.copy(orthoViewer.camera.position).sub(center);
    orthoPlane.position.copy(center);
    orthoPlane.lookAt(orthoViewer.camera.position);
    var intersects = orthoRaycaster.intersectObject(orthoPlane);
    var controlIntersects = orthoRaycaster.intersectObject(clickedTagMesh);
    if (
      !intersects ||
      !intersects.length ||
      !controlIntersects ||
      !controlIntersects.length
    ) {
      isTeethMoving = false;
      clickedTagMesh = null;
      return;
    }
    clickControlPoint.copy(controlIntersects[0].point);

    clickPoint.copy(intersects[0].point);
    offset.copy(intersects[0].point).sub(orthoPlane.position);

    moveContext.tag = tag;
    moveContext.isRotated = false;

    if (tag == "xMoveArrow") {
      moveContext.from = new THREE.Vector3(-radius, 0, 0);
      moveContext.to = new THREE.Vector3(radius, 0, 0);
      moveContext.from.applyMatrix4(boxMatrix);
      moveContext.to.applyMatrix4(boxMatrix);
    } else if (tag == "yMoveArrow") {
      moveContext.from = new THREE.Vector3(0, -radius, 0);
      moveContext.to = new THREE.Vector3(0, radius, 0);
      moveContext.from.applyMatrix4(boxMatrix);
      moveContext.to.applyMatrix4(boxMatrix);
    } else if (tag == "zMoveArrow") {
      moveContext.from = new THREE.Vector3(0, 0, -radius);
      moveContext.to = new THREE.Vector3(0, 0, radius);
      moveContext.from.applyMatrix4(boxMatrix);
      moveContext.to.applyMatrix4(boxMatrix);
    } else {
      moveContext.isRotated = true;
      rotateAxis = new THREE.Vector3();
      let rotateRadius = 18;
      let viewPoint = orthoViewer.camera.position;
      if (tag == "xRotateRing") {
        // redRing
        if (viewPoint && viewPoint.x < center.x) {
          rotateRadius = -rotateRadius;
        }
        moveContext.to = new THREE.Vector3(rotateRadius, 0, 0);
        normal.copy(moveContext.to);
      } else if (tag == "yRotateRing") {
        // blueRing
        if (viewPoint && viewPoint.y < center.y) {
          rotateRadius = -rotateRadius;
        }
        moveContext.to = new THREE.Vector3(0, rotateRadius, 0);
        normal.copy(moveContext.to);
      } else if (tag == "zRotateRing") {
        // greenRing
        if (viewPoint && viewPoint.z < center.z) {
          rotateRadius = -rotateRadius;
        }
        moveContext.to = new THREE.Vector3(0, 0, rotateRadius);
        normal.copy(moveContext.to);
      }
      moveContext.to.applyMatrix4(boxMatrix);

      let start = moveContext.to;
      let end = moveContext.center;

      rotateAxis.subVectors(start, end).normalize();
    }
  }
}

function moveModeMouseMove(event) {
  let deltaTime = window.performance.now() - updateTime;
  if (
    ((isTeethMoving && isAnySelected()) || movedControlMesh) &&
    deltaTime > 20
  ) {
    updateTime = window.performance.now();
    if (event.preventDefault) event.preventDefault();

    var direction = vueApp.isIntraoralView
      ? getIoMouse3dDirection(event)
      : getMouse3dDirection(event);
    if (!direction) return;

    orthoRaycaster.set(orthoViewer.camera.position, direction);

    var intersects = orthoRaycaster.intersectObject(orthoPlane);
    if (intersects.length > 0) {
      if (moveContext.isRotated) {
        var mousePoint = intersects[0].point;
        var rotateCenter = moveContext.center;
        var v1 = new THREE.Vector3();
        v1.copy(clickPoint).sub(rotateCenter);

        var v2 = new THREE.Vector3();
        v2.copy(mousePoint).sub(rotateCenter);

        var planeAngle = v1.angleTo(v2);
        clickPoint.copy(mousePoint);

        var controlAngle = 0;
        var controlIntersects = clickedTagMesh
          ? orthoRaycaster.intersectObject(clickedTagMesh)
          : [];
        if (controlIntersects.length > 0) {
          var mouseControlPoint = controlIntersects[0].point;

          v1 = new THREE.Vector3();
          v1.copy(clickControlPoint).sub(rotateCenter);

          v2 = new THREE.Vector3();
          v2.copy(mouseControlPoint).sub(rotateCenter);

          controlAngle = v1.angleTo(v2);
          clickControlPoint.copy(mouseControlPoint);
        } else {
          //   clickedTagMesh = null;
          // if (!clickedTagMesh)
          // isTeethMoving = false;
          // movedControlMesh = null;
          return;
          // moveModeMouseUp(null, null);
        }
        // var angle = Math.abs(planeAngle) > Math.abs(controlAngle) ? planeAngle : controlAngle;
        var angle = controlAngle ? controlAngle : planeAngle;
        // if (angle < 0.05) return;
        // console.log(
        //   "moveContext.isRotated",
        //   moveContext.tag,
        //   angle,
        //   controlAngle
        // );

        var cross = v1.cross(v2);
        var direction = normal.clone().dot(cross);
        angle *= 2;
        if (direction < 0) {
          angle = 2 * Math.PI - angle;
        }
      }
      // console.log("moveContext.isRotated", moveContext.tag, angle);
      // console.log(moveContext.center.y, clickPoint.y, mousePoint.y);
      if (isTeethMoving) {
        if (moveContext.isRotated) {
          selectedMeshes.forEach((selectedMesh) => {
            rotateAboutPoint(selectedMesh, rotateCenter, rotateAxis, angle);
          });
          // let angleX = moveContext.tag == "xRotateRing" ? angle : 0;
          // let angleY = moveContext.tag == "yRotateRing" ? -angle : 0;
          // let angleZ = moveContext.tag == "zRotateRing" ? angle : 0;
          clickPoint.copy(mousePoint);
        } else {
          var pos = intersects[0].point.sub(offset);
          var point = getPointHonBC(pos, moveContext.from, moveContext.to);

          let movedGroup = moveContext.moveLine;
          // let mp = movedGroup.position;
          // let lpOffset = [point.x - mp.x, point.y - mp.y, point.z - mp.z];
          // applyRotateToGingiva();
          // applyMoveToGingiva(lpOffset);

          movedGroup.position.copy(point);

          selectedMeshes.forEach((selectedMesh) => {
            selectedMesh.position.copy(point);
            if (selectedMesh.subvector) {
              selectedMesh.position.sub(selectedMesh.subvector);
            }
          });
        }
        needUpdate = true;
      } else if (movedControlMesh) {
        if (moveContext.isRotated) {
          // if (moveContext.tag == "yRotateRing") {
          //   // blueRing
          //   angle = moveContext.center.y > clickPoint.y ? -angle : angle;
          //   rotateAroundAxisY(null, angle, movedControlMesh, movedControlMesh);
          // } else if (moveContext.tag == "zRotateRing") {
          //   // greenRing
          //   angle = moveContext.center.z > clickPoint.z ? angle : -angle;
          //   rotateAroundAxisZ(null, -angle, movedControlMesh, movedControlMesh);
          // } else if (moveContext.tag == "xRotateRing") {
          //   // redRing
          //   angle = moveContext.center.x > clickPoint.x ? angle : -angle;
          //   rotateAroundAxisX(null, -angle, movedControlMesh, movedControlMesh);
          // }

          // rotateAboutPoint(movedControlMesh, rotateCenter, rotateAxis, angle);
          movedControlMesh.rotateOnAxis(rotateAxis, angle); // rotateOnWorldAxis rotateOnAxis

          clickPoint.copy(mousePoint);
          // console.log("movedControlMesh R", movedControlMesh.rotation);
        } else {
          let point = intersects[0].point.sub(offset);
          // var pos = intersects[0].point.sub(offset);
          // var point = getPointHonBC(pos, moveContext.from, moveContext.to);
          movedControlMesh.position.copy(point);
        }
        // needUpdate = true;
      }
    }
  }
}

function moveModeMouseUp(event, upMesh) {
  // console.clear();
  //$('#stl_cont').css('cursor', 'default');
  let needSelection = !selectedMeshes && !movedControlMesh;
  if (isAnySelected()) {
    let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;

    if (
      gingivae &&
      gingivae.length &&
      selectedMeshes &&
      selectedMeshes.length
    ) {
      if (selectedMeshes.length == 1) {
        applyRotateToGingiva();
      } else {
        let toothContext = moveContext.editedObject;
        applyMultiselectRotateToGingiva(
          orthoViewer,
          toothContext.selectedTeeth,
          gingivae
        );
      }
    }

    if (!vueApp.isIntraoralView) {
      findToothCollisions(moveContext.tooth);
      findToothAnchorageLoss(moveContext.tooth);
    }
  }

  if (upMesh) {
    if (upMesh.moveRotateGroup)
      upMesh.moveRotateGroup.position.copy(upMesh.position);
    upMesh.subvector = null;
  } else {
    let tempMesh = null;
    if (moveContext && moveContext.id) {
      tempMesh = orthoViewer.get_model_mesh(moveContext.id);
    }

    if (moveContext.moveLine) {
      // tempMesh.subvector = tempMesh.moveRotateGroup.position
      //   .clone()
      //   .sub(tempMesh.position);

      moveContext.moveLine.children.forEach((child) => {
        if (child.defaultColor) {
          child.material.color = new THREE.Color(child.defaultColor);
        }
      });
    }
  }

  orthoViewer.controls.enabled = true;
  movedControlMesh = null;
  clickedTagMesh = null;
  isTeethMoving = false;
  if (needUpdate) {
    // redrawMoveArrow();
    vueApp.$emit("positionChanged", moveContext.tooth);
    needUpdate = false;
  }
  return needSelection;
}

function moveByTap(dx) {
  if (dx != 0) {
    var mesh = orthoViewer.get_model_mesh(moveContext.id);
    var from = mesh.position; //moveContext.from;
    var to = moveContext.to;
    var length = to.clone().sub(from).length();
    var value = dx / length;
    var newX = from.x + (to.x - from.x) * value;
    var newY = from.y + (to.y - from.y) * value;
    var newZ = from.z + (to.z - from.z) * value;
    var point = new THREE.Vector3(newX, newY, newZ);

    // change root apex ?
    // updateToothBeforeMove(moveContext.tooth, mesh.position, point);

    mesh.position.copy(point);
    redrawMoveArrow();
    vueApp.$emit("positionChanged", moveContext.tooth);
  }
}

function moveByTag(tag) {
  if (tag) {
    switch (tag) {
      case "from":
        moveByTap(-1);
        break;
      case "to":
        moveByTap(1);
        break;
    }
  }
}

function moveModeValueChanged(value) {
  moveContext.angle = value * Math.PI;
  redrawMoveArrow();
  // var mesh = orthoViewer.get_model_mesh(moveContext.id);
  // if (mesh) {
  // 	var from = moveContext.from;
  // 	var to = moveContext.to;
  // 	var newX = from.x + (to.x - from.x) * value;
  // 	var newY = from.y + (to.y - from.y) * value;
  // 	var newZ = from.z + (to.z - from.z) * value;
  // 	var point = new THREE.Vector3(newX, newY, newZ);
  // 	mesh.position.copy(point);
  // }
}

function changeMovePlane(isVertical) {
  moveContext.angle = moveContext.editedObject.sliderValue = 0;
  $("#movementVector").slider("value", 0);
  $("#movementVector2").slider("value", 0);
  moveContext.isVerticalPlane = isVertical;
  redrawMoveArrow();
}

export {
  enterMoveMode,
  exitMoveMode,
  moveModeMouseDown,
  moveModeMouseMove,
  moveModeMouseUp,
  moveModeValueChanged,
  redrawMoveArrow,
  moveByTap,
  moveByTag,
  changeMovePlane,
  moveModeTagDetected,
};
